import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ac49df82"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "right header-controls" };
const _hoisted_2 = { class: "toggle" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-copy" }, null, -1 /* HOISTED */));
const _hoisted_5 = { class: "panel-wrapper__content" };
const _hoisted_6 = { key: 0 };
import { computed, ref } from "vue";
import JSONTree from "src/shared/v-components/ui/json-tree/JSONTree.vue";
import Button from "../Button.vue";
import ExtoleDrawer from "../ExtoleDrawer.vue";
import { useClipboard, useWindowSize, useLocalStorage } from "@vueuse/core";
import { ElMessage } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'JsonDrawer',
    props: {
        title: {},
        data: {},
        level: {},
        foldedProps: {},
        requireSort: { type: Boolean },
        raw: { type: Boolean }
    },
    emits: ["closed"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isShown = ref(true);
        const jsonViewType = ref(props.raw ? "raw" : "pretty");
        const { width } = useWindowSize();
        const drawerWidth = useLocalStorage("json-drawer-width", width.value * 0.4);
        const isResizing = ref(false);
        const resizer = ref(null);
        const toggleOptions = [
            { value: "pretty", displayName: "Pretty" },
            { value: "raw", displayName: "Raw" },
        ];
        const ignoredKeys = [
            "componentCommonImpl",
            "campaignComponentVariableCommonImpl",
        ];
        const cleanedData = computed(() => {
            const removeIgnoredKeys = (obj) => {
                if (Array.isArray(obj)) {
                    return obj.map(removeIgnoredKeys);
                }
                else if (obj !== null && typeof obj === "object") {
                    return Object.keys(obj).reduce((acc, key) => {
                        if (!ignoredKeys.includes(key)) {
                            acc[key] = removeIgnoredKeys(obj[key]);
                        }
                        return acc;
                    }, {});
                }
                return obj;
            };
            return removeIgnoredKeys(props.data);
        });
        const stringifiedData = computed(() => JSON.stringify(cleanedData.value, null, 2));
        const { text, copy, copied, isSupported } = useClipboard({
            source: stringifiedData,
        });
        const copyText = () => {
            if (isSupported.value) {
                copy();
                ElMessage.info("Copied!");
            }
        };
        const resize = (e) => {
            if (isResizing.value) {
                const newWidth = width.value - e.pageX;
                drawerWidth.value = newWidth;
            }
        };
        const stopResize = () => {
            isResizing.value = false;
            document.removeEventListener("mousemove", resize);
            document.removeEventListener("mouseup", stopResize);
        };
        const startResize = (e) => {
            e.preventDefault();
            isResizing.value = true;
            document.addEventListener("mousemove", resize);
            document.addEventListener("mouseup", stopResize);
        };
        const toggleJSONViewType = (value) => {
            jsonViewType.value = value;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ExtoleDrawer, {
                ref: "drawerComponentRef",
                modelValue: isShown.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((isShown).value = $event)),
                onClosed: _cache[1] || (_cache[1] = ($event) => (emit('closed'))),
                showClose: false,
                width: `${_unref(drawerWidth)}px`,
                "lock-scroll": true,
                "hide-mask": true,
                "close-on-press-escape": true
            }, {
                title: _withCtx(() => [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("ul", null, [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(toggleOptions, (option) => {
                                    return _createElementVNode("li", {
                                        key: option.displayName,
                                        onClick: ($event) => (toggleJSONViewType(option.value)),
                                        class: _normalizeClass({ active: jsonViewType.value === option.value })
                                    }, [
                                        _createElementVNode("a", null, _toDisplayString(option.displayName), 1 /* TEXT */)
                                    ], 10 /* CLASS, PROPS */, _hoisted_3);
                                }), 64 /* STABLE_FRAGMENT */))
                            ])
                        ]),
                        _createVNode(Button, {
                            level: 'secondary',
                            shape: 'square',
                            size: "large",
                            onClick: copyText
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" Copy icon "),
                                _hoisted_4
                            ]),
                            _: 1 /* STABLE */
                        })
                    ])
                ]),
                default: _withCtx(() => [
                    _createElementVNode("div", {
                        ref_key: "resizer",
                        ref: resizer,
                        class: "resizer",
                        onMousedown: startResize
                    }, null, 544 /* NEED_HYDRATION, NEED_PATCH */),
                    _createElementVNode("div", _hoisted_5, [
                        (jsonViewType.value === 'raw')
                            ? (_openBlock(), _createElementBlock("pre", _hoisted_6, _toDisplayString(stringifiedData.value), 1 /* TEXT */))
                            : (_openBlock(), _createBlock(JSONTree, {
                                key: 1,
                                data: cleanedData.value,
                                level: _ctx.level,
                                foldedProps: _ctx.foldedProps,
                                requireSort: _ctx.requireSort
                            }, null, 8 /* PROPS */, ["data", "level", "foldedProps", "requireSort"]))
                    ])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue", "width"]));
        };
    }
});
